/**
 * 地図レイヤーのzIndex定数
 *
 * レイヤーの重なり順序（下から上）:
 * 1. ベースマップ（OSM） - Leafletデフォルト
 * 2. 地図サービス層（ゼンリン、GEOSPACE）、航空写真（全国最新写真）
 * 3. データレイヤー層（用途地域、公示価格、ハザード、学校区など）
 * 4. オーバーレイ層（ピン、検索結果など）
 */
export const LAYER_Z_INDEX = {
  // ベースマップ層 (1-9)

  // 地図サービス層 (10-99)
  // 地図サービスのベースマップ
  ZENRIN_RESIDENTIAL: 10, // ゼンリン住宅地図（表札なし）
  GEOSPACE_CDS: 10, // GEOSPACE CDS地図
  // ZENRIN_RESIDENTIAL+1
  ZENRIN_FETCHED_IMAGE: 11, // 取得した住宅地図（表札あり）
  // 全国最新写真（国土地理院）
  SEAMLESS_PHOTO: 12,
  // ゼンリン・GEOSPACE等の地図タイル
  ZENRIN_BLUE_MAP: 13, // ゼンリンブルーマップ
  LEGAL_AFFAIRS_CHIBAN: 13, // 法務省地番地図
  GEOSPACE_CHIBAN: 13, // GEOSPACE地番地図
  TRUSTART_CHIBAN: 14, // 役所地番地図（TRUSTART地番図データ。GEOSPACEの上に重畳表示）
  MAPLIBRE: 99, // MapLibreに関するレイヤー

  // データレイヤー層 (100-299)
  // 用途地域、公示価格、ハザードマップなど
  AREA_USE_PURPOSE: 100, // 用途地域
  LAND_PRICE: 100, // 公示価格
  TRADE_PRICE: 100, // 取引価格
  HAZARD: 200, // ハザードマップ（洪水、津波、土砂災害など）
  SCHOOL_AREA: 200, // 学校区
  IDOL_FARMLAND: 200, // 遊休農地
  FARMLAND: 200, // 農地
  CITY_PLANNING_AREA: 200, // 都市計画区域
  FIRE_PROTECTION_AREA: 200, // 防火・準防火地域
  HIGH_LEVEL_AREA: 200, // 高度地区
  HIGH_LEVEL_USE_AREA: 200, // 高度利用地区
  DISASTER_RISK_AREA: 200, // 災害危険区域
  ROAD: 200, // 道路
  // オーバーレイ層 (300+)
  // ピン、検索結果、プロットなど
  SAVED_PLOT: 300, // 保存プロット
  REAL_ESTATE_SEARCH: 300, // 不動産検索結果
  REQUESTED_PICTURES_PLOT: 300, // 登記解析済み登記情報
  RECEPTION_BOOK: 300, // 受付帳情報ピン
  CURRENT_LOCATION: 400, // 現在地マーカー・精度円
} as const;

export type LayerZIndexKey = keyof typeof LAYER_Z_INDEX;
